export default {
  title: {
    en: 'Want to plan an unforgettable party?',
    ar: 'طفلك يستاهل حفلة مليااانة حب '
  },
  text: {
    en: "Find the nearest McDonald's restaurant.",
    ar: '!شيك على أقرب فرع ماك لك '
  },
  bookPartyButton: {
    label: {
      en: 'Book A Party',
      ar: 'أحجز حفلة'
    },
    url: {
      en: 'https://www.mcdksa.com/contact-us/en.html',
      ar: 'https://www.mcdksa.com/contact-us/ar.html'
    }
  }
};
